import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { initLiff } from './lib/liff.ts';
import { ToastProvider } from './components/ui/toast';
import { ConfirmProvider } from './components/ui/confirm';
import { ConsequenceProvider } from './components/ui/ConsequencePreview';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

async function bootstrap() {
  const root = document.getElementById('root');
  if (!root) throw new Error('No #root');

  // Init LIFF เสมอ — แต่ initLiff() "ไม่" auto-redirect ไป LINE แล้ว (ดู lib/liff.ts)
  // เลยปลอดภัยกับคนที่เปิดผ่านเบราว์เซอร์: ถ้าไม่ได้ login LINE → getIDToken=null →
  // App เด้งไปหน้า login (user/pass + ปุ่ม LINE + สมัครทดลองใช้). ต้อง init ให้เสร็จ
  // เพื่อให้ปุ่ม "เข้าด้วย LINE" เรียก liff.login() ได้. ถ้า init พังก็ยัง render
  // หน้าเว็บได้ (user/pass ไม่ต้องใช้ LIFF) — แค่ปุ่ม LINE จะใช้ไม่ได้.
  try {
    await initLiff();
  } catch (e) {
    console.error('LIFF init failed (web login still works):', e);
  }

  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <ConfirmProvider>
            <ConsequenceProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ConsequenceProvider>
          </ConfirmProvider>
        </ToastProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}


bootstrap();
